import { Search } from "@mui/icons-material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { InputAdornment } from "@mui/material";
import { TextField } from "@mui/material";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { useHistory } from "react-router-dom";
import "./Header.css";

const Header = ({ children, hasHiddenAuthButtons }) => {
  const history =  useHistory();
    return (
      <Box className="header">
        <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
        </Box>
        {
          children
        }
        {
          !hasHiddenAuthButtons ? 
          localStorage.getItem('token') === null ?
          <Box>
            <Button variant="text" onClick={() => history.push('/login', {from: "Header"})}>LOGIN</Button>
            <Button variant="contained" onClick={() => history.push('/register', {from: "Header"})}>REGISTER</Button>
          </Box>
          :
          <Box display="flex" alignItems="center">
            <Avatar alt={localStorage.getItem("username")} src="avatar.png"></Avatar>
            {localStorage.getItem("username")}
            <Button variant="text" onClick={() => {
              localStorage.clear();
              history.push('/', {from: "Header"});
              window.location.reload();
            }}>LOGOUT</Button>
          </Box>
          :
          <Button
            className="explore-button"
            startIcon={<ArrowBackIcon />}
            variant="text"
            onClick={() => {history.push("/", {from: "Header"})}}
          >
            Back to explore
          </Button>
        }
      </Box>
    );
};

export default Header;
